import { ApiProperty } from "@nestjs/swagger";

export class ImageReqDto {
    @ApiProperty()
    id:number

    @ApiProperty()
    modifiedOriginalName:string


}
